import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Card, PublicContainer } from '@mts/ui';
import { usePublicTenant } from '../../hooks/usePublicTenant';

function PublicContentPage({
  eyebrow,
  title,
  description,
  highlights = [],
  cta,
  children,
}) {
  const { brandTheme } = usePublicTenant();
  const pageBg = brandTheme?.background || '#F8FAFC';
  const surfaceBg = brandTheme?.surface || '#FFFFFF';
  const surfaceAltBg = brandTheme?.card || '#F8FAFC';
  const surfaceBorder = brandTheme?.border || '#E2E8F0';
  const headingColor = brandTheme?.text || '#0F172A';
  const bodyColor = brandTheme?.muted || '#475569';
  const cardTitleColor = brandTheme?.text || '#0F172A';
  const cardBodyColor = brandTheme?.muted || '#475569';

  return (
    <div className="py-12 lg:py-16" style={{ backgroundColor: pageBg }}>
      <PublicContainer>
        <div className="rounded-2xl border p-8 shadow-sm lg:p-12" style={{ backgroundColor: surfaceBg, borderColor: surfaceBorder }}>
          {eyebrow ? (
            <Badge variant="primary" className="mb-4">{eyebrow}</Badge>
          ) : null}
          <h1 className="font-display text-3xl font-bold lg:text-4xl" style={{ color: headingColor }}>{title}</h1>
          <p className="mt-4 max-w-3xl font-body text-[16px] leading-7" style={{ color: bodyColor }}>{description}</p>

          {highlights.length > 0 ? (
            <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
              {highlights.map((item) => (
                <Card key={item.title} padding="lg" shadow="none" className="h-full border" style={{ borderColor: surfaceBorder, backgroundColor: surfaceAltBg }}>
                  <h2 className="font-display text-lg font-semibold" style={{ color: cardTitleColor }}>{item.title}</h2>
                  <p className="mt-2 font-body text-sm" style={{ color: cardBodyColor }}>{item.body}</p>
                </Card>
              ))}
            </div>
          ) : null}

          {children ? <div className="mt-8">{children}</div> : null}

          {cta ? (
            <div className="mt-8">
              <Link to={cta.href}>
                <Button variant="primary">{cta.label}</Button>
              </Link>
            </div>
          ) : null}
        </div>
      </PublicContainer>
    </div>
  );
}

export default PublicContentPage;
